export const userTagModuleStatusColor = (status: string) => {
  switch (status) {
    case "published":
      return "green";
    case "draft":
      return "orange";
    default:
      return "gray";
  }
};

export const userTagModuleStatusLabel = (status: string) => {
  switch (status) {
    case "published":
      return "公開中";
    case "draft":
      return "下書き";
    default:
      return "アーカイブ";
  }
};

export const formatUserTagModuleDate = (iso: string | null) => {
  if (!iso) return "-";
  return new Date(iso).toLocaleString("ja-JP", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
